import {InjectionToken} from '@angular/core'
import { environment } from 'src/environments/environment';
import { Environment } from 'src/types/environment';
 
export const ENV = new InjectionToken<Environment>('env')
 
export function getEnv(): Environment {
  return environment;
}